import React from 'react';
import {PropTypes} from 'prop-types';
import styled from "@emotion/styled";
import Popover from "@material-ui/core/Popover";
import {makeStyles, withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {logout} from "../../utils/auth";
import {useHistory} from 'react-router-dom'
import {connect} from "react-redux";
import * as UserAction from "../../redux/actions/AuthActions"
import {bindActionCreators} from "redux";

const CustomerPopover = withStyles({
    // root: {
    //     zIndex: 1000,
    //     margin: "10px",
    // }
})(Popover);


const UserInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
`;

const NameWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    align-items: center;
    text-align: center;
    color: ${props => props.mode === "selected" ? "var(--company-success)" : (props.mode === "disabled") ? "var(--font-secondary)" : "var(--company)"};
    svg {
      margin-left: var(--space-s);
    }
`;

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },
}));

function UserInfoPopOver(props) {
    const {anchorEl, onClose, user, userActions} = props;
    const classes = useStyles();
    const history = useHistory();

    const handleClose = () => {
        onClose()
    };

    const onLogoutBtnClick = () => {
        userActions.logout();
        logout();
        history.push("/login")
    };

    const open = Boolean(anchorEl);

    return (
        <CustomerPopover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <UserInfoWrapper>
                <NameWrapper> {user.firstName} {user.lastName} </NameWrapper>

                <Button color="secondary" className={classes.button} onClick={onLogoutBtnClick}>
                    Logout
                </Button>

            </UserInfoWrapper>
        </CustomerPopover>
    );
}

UserInfoPopOver.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func.isRequired,
    user: PropTypes.any.isRequired,
    userActions: PropTypes.object.isRequired
};
UserInfoPopOver.defaultProps = {};

function mapStateToProps(state) {
    return {
        user: state.auth
    }
}

function mapDispatcherToProps(dispatch) {
    return {
        userActions: bindActionCreators(UserAction, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatcherToProps)(UserInfoPopOver);
